module.exports = __webpack_public_path__ + "img/user_SongBo.1dc623e4.png";